var ADDON_ID="storybook/highlight",HIGHLIGHT_STYLE_ID="storybookHighlight",HIGHLIGHT=`${ADDON_ID}/add`,RESET_HIGHLIGHT=`${ADDON_ID}/reset`;

export { HIGHLIGHT, HIGHLIGHT_STYLE_ID, RESET_HIGHLIGHT };
